import { createSlice } from "@reduxjs/toolkit";

// Slice to store the list of tasks returned by APIs
const taskDataSlice = createSlice({
  name: "taskData",
  initialState: [],
  reducers: {
    setTaskData: (_state, action) => action.payload,
    updateTaskData: (state, action) => {
      const tempState = [...state];
      const taskId = action.payload.id;
      if (tempState[taskId] && tempState[taskId].TASKS_STATUS) {
        tempState[taskId].TASKS_STATUS.statusId = action.payload.status;
      }
      return tempState;
    },
    removeTaskData: (state) => {
      const localState = [...state];
      return localState;
    },
  },
});

// Slice to store task detail information
const taskDetailsSlice = createSlice({
  name: "taskDetails",
  initialState: [],
  reducers: {
    setTaskDetails: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

// Slice to store gantt schedule information
const ganttDetailsSlice = createSlice({
  name: "ganttDetails",
  initialState: [],
  reducers: {
    setScheduleDetails: (_state, action) => ({
      ...action.payload,
    }),
    deleteScheduleDetails: () => [],
  },
});

// Slice to store task types
const taskTypesSlice = createSlice({
  name: "taskTypes",
  initialState: [],
  reducers: {
    setTaskTypes: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

// Slice used for slider timer data
const sliderTimerSlice = createSlice({
  name: "sliderTimer",
  initialState: [],
  reducers: {
    setScheduleSliderTime: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

// Slice for selection set elements associated with tasks
const selectionSetElementsSlice = createSlice({
  name: "selectionSetTaskElements",
  initialState: [],
  reducers: {
    setSelectionSetTaskElements: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

// Slice for running tasks cost (numeric value)
const runningTasksCostSlice = createSlice({
  name: "runningTasksCost",
  initialState: 0,
  reducers: {
    setTaskCost: (_state, action) => action.payload,
  },
});

export const { setTaskData, updateTaskData, removeTaskData } = taskDataSlice.actions;
export const { setTaskDetails } = taskDetailsSlice.actions;
export const { setScheduleDetails, deleteScheduleDetails } = ganttDetailsSlice.actions;
export const { setTaskTypes } = taskTypesSlice.actions;
export const { setScheduleSliderTime } = sliderTimerSlice.actions;
export const { setSelectionSetTaskElements } = selectionSetElementsSlice.actions;
export const { setTaskCost } = runningTasksCostSlice.actions;

export const TaskData = taskDataSlice.reducer;
export const TaskDetails = taskDetailsSlice.reducer;
export const GanttDetails = ganttDetailsSlice.reducer;
export const TaskTypes = taskTypesSlice.reducer;
export const sliderTimer = sliderTimerSlice.reducer;
export const selectionSetTaskElements = selectionSetElementsSlice.reducer;
export const runningTasksCost = runningTasksCostSlice.reducer;

export default {
  TaskData,
  TaskDetails,
  GanttDetails,
  TaskTypes,
  sliderTimer,
  selectionSetTaskElements,
  runningTasksCost,
};
